import { useNavigate } from "react-router-dom";
import { BookmarkSquareIcon, DocumentDuplicateIcon, UsersIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

type ActionMenuVariant = "individual" | "team" | "saved";

type ActionMenuProps = {
  variant: ActionMenuVariant;
  className?: string;
  onSave?: () => void;
  isSaveLoading?: boolean;
};

const baseButtonClass =
  "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-primary-200 disabled:cursor-not-allowed disabled:opacity-60";

export function ActionMenu({ variant, className, onSave, isSaveLoading }: ActionMenuProps) {
  const navigate = useNavigate();

  const actions =
    variant === "individual"
      ? [
          {
            key: "my-calculations",
            label: "Meus cálculos",
            icon: DocumentDuplicateIcon,
            className: "border border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50",
            onClick: () => navigate("/calculator/saved"),
            disabled: false,
          },
          {
            key: "team-calculator",
            label: "Calcular Time",
            icon: UsersIcon,
            className:
              "border border-primary-200 bg-primary-50/80 text-primary-700 hover:border-primary-300 hover:bg-primary-50",
            onClick: () => navigate("/calculator/team"),
            disabled: false,
          },
        ]
      : variant === "team"
      ? [
          {
            key: "my-calculations",
            label: "Meus cálculos",
            icon: DocumentDuplicateIcon,
            className: "border border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50",
            onClick: () => navigate("/calculator/saved"),
            disabled: false,
          },
          {
            key: "individual-calculator",
            label: "Calculadora Individual",
            icon: UsersIcon,
            className:
              "border border-primary-200 bg-primary-50/80 text-primary-700 hover:border-primary-300 hover:bg-primary-50",
            onClick: () => navigate("/calculator"),
            disabled: false,
          },
          {
            key: "save",
            label: "Salvar",
            icon: BookmarkSquareIcon,
            className: "bg-primary-600 text-white hover:bg-primary-500",
            onClick: onSave,
            disabled: !onSave || isSaveLoading,
          },
        ]
      : [
          {
            key: "individual-calculator",
            label: "Calculadora Individual",
            icon: UsersIcon,
            className:
              "border border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50",
            onClick: () => navigate("/calculator"),
            disabled: false,
          },
          {
            key: "team-calculator",
            label: "Calculadora de Time",
            icon: UsersIcon,
            className:
              "border border-primary-200 bg-primary-50/80 text-primary-700 hover:border-primary-300 hover:bg-primary-50",
            onClick: () => navigate("/calculator/team"),
            disabled: false,
          },
        ];

  return (
    <div className={clsx("flex flex-wrap items-center gap-3", className)}>
      {actions.map(({ key, label, icon: Icon, className: buttonClass, onClick, disabled }) => (
        <button
          key={key}
          type="button"
          onClick={onClick}
          className={clsx(baseButtonClass, buttonClass)}
          disabled={disabled}
        >
          <Icon className="h-5 w-5 text-current" />
          {label}
          {key === "save" && isSaveLoading && (
            <span className="text-xs font-normal text-white/80">(salvando...)</span>
          )}
        </button>
      ))}
    </div>
  );
}
